const API_URL = process.env.REACT_APP_API_BASE_URL || '';

export const PersonalService = {
    getAll: async (authorizedFetch) => {
        const res = await authorizedFetch(`${API_URL}/api/employees`);
        if (!res.ok) throw new Error(await res.text());
        return res.json();
    },

    getById: async (id, authorizedFetch) => {
        const res = await authorizedFetch(`${API_URL}/api/employees/${id}`);
        if (!res.ok) throw new Error(await res.text());
        return res.json();
    },

    create: async (data, authorizedFetch) => {
        const res = await authorizedFetch(`${API_URL}/api/employees`, {
            method: 'POST',
            body: JSON.stringify(data),
        });
        if (!res.ok) throw new Error(await res.text());
        return res.json();
    },

    update: async (id, data, authorizedFetch) => {
        const res = await authorizedFetch(`${API_URL}/api/employees/${id}`, {
            method: 'PUT',
            body: JSON.stringify(data),
        });
        if (!res.ok) throw new Error(await res.text());
        return res.json();
    },

    remove: async (id, authorizedFetch) => {
        const res = await authorizedFetch(`${API_URL}/api/employees/${id}`, { method: 'DELETE' });
        if (!res.ok) throw new Error(await res.text());
        return res.json();
    },
};
